module.exports = __webpack_public_path__ + "media/components/Builder/Library/Images/Tools/Roller-7beea0461f34ab2acc51c5e1b5df9b23.png";